export const calculateSubtotal = (cartLineItems) => {
	let amount = 0;
	cartLineItems.forEach((item) => {
		const {
			variant: { price },
			quantity,
		} = item;
		amount += quantity * price;
	});
	return amount;
};

export const calculateTotalAmount = (
	subtotal,
	totalTax,
	totalDiscounts,
	shipping
) => {
	const shippingRate = shipping?.rate ? parseFloat(shipping.rate) : 0;
	return (
		parseFloat(subtotal) +
		parseFloat(totalTax) +
		parseFloat(shippingRate) +
		parseFloat(totalDiscounts)
	);
};
